<script lang="ts" setup></script>

<template>
  <div class="magazine">
    <div class="spine sticky top-0 sm:h-dvh bg-black z-40">
      <Navigation></Navigation>
    </div>
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.magazine {
  @media (min-width: 640px) {
    display: grid;
    grid-template-columns: auto 1fr;
  }

  .content {
    grid-column: 2;
    min-height: calc(100vh - 72px);
  }
}
</style>
